<template>
    <div>
        重定向中，请稍后...
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import Vue from 'vue'
const constants = require('@/util/constants')

export default {
  name: 'redirect',
  data () {
    return {
      hello: 'world'
    }
  },
  methods: {
    ...mapActions([ 'updateLogin' ])
  },
  mounted () {
    //
    localStorage.access_token = Vue.ls.get(constants.ACCESS_TOKEN)
    console.log('redirect access_token: ', localStorage.access_token)
    // 登入更新状态
    this.updateLogin()
    // 跳转管理后台
    let _this = this
    setTimeout(() => {
      _this.$router.replace('/admin')
    }, 3000)
  }
}
</script>
